export const RECIPIENT_TYPES = {
  DEVICE: 'DEVICE',
  DYNAMIC_TEAM: 'DYNAMIC_TEAM',
  GROUP: 'GROUP',
  PERSON: 'PERSON',
  WEB_SERVICE_USER: 'WEB_SERVICE_USER',
};

export const LicenseTypes = {
  FULL_USER: 'FULL_USER',
  STAKEHOLDER_USER: 'STAKEHOLDER_USER',
};
